import { useQuery } from 'react-query';

import { getVisitsToObject } from 'api/visitReports/createVisitReport/getVisitList';

export const useGetVisitsToObject = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('visitsToObject', () => getVisitsToObject(slug), {
    refetchOnWindowFocus: false,
  });

  return { visitToObjectOptions: data, refetch, isLoading };
};

export default useGetVisitsToObject;
